import React from 'react'
import Navbar from '../../navbar/Navbar'
import Footer from '../../footer/Footer'
import "./about.css"

function About() {
  return (
    <div>
      <Navbar/>
      <div className="about_container">

      </div>
      <Footer/>
    </div>
  )
}

export default About